import { formatInternational } from 'lib-shared-phone-numbers';
import type { ConversationNodeForward } from 'lib-shared-types-api';

type RoutedThroughForwardProps = {
  node: ConversationNodeForward;
};

export function RoutedThroughForward({
  node,
}: RoutedThroughForwardProps): JSX.Element {
  return (
    <>
      Forward · To{' '}
      <strong>
        {formatInternational(node.phone_number) || node.phone_number}
      </strong>{' '}
      ({node.call_pattern})
    </>
  );
}
